export default __webpack_public_path__ + "static/media/sendSurvey.0be64a17.png";